export default __webpack_public_path__ + "static/media/habano5.a4dd1d3e.png";